import PropTypes from 'prop-types';
import { Modal, Typography } from 'antd';
// import imgError from 'assets/images/DeleteForever/delete_forever.svg';
import success from '../../../assets/images/Notificacion/Noti_validacion.svg';
import notificacionError from '../../../assets/images/Notificacion/Noti_error.svg';
import './InfoModal.scss';

const { Text } = Typography;

const InfoModal = ({ open, onClose, message, visibleMessage }) => {
  const handleClose = () => {
    onClose?.();
  };
  return (
    <Modal
      title=""
      open={open}
      width="45em"
      onCancel={handleClose}
      okButtonProps={{ style: { display: 'none' } }}
      cancelButtonProps={{ style: { display: 'none' } }}>
      <div className="info-modal">
        {visibleMessage ? (
          <img className="info-modal-imagen" alt="NotificacionError" src={notificacionError} />
        ) : (
          <img className="info-modal-imagen" alt="NotificacionSucces" src={success} />
        )}
        <Text className="info-modal-descripcion">
          {visibleMessage ? message : 'Notificación enviada exitosamente.'}
        </Text>
      </div>
    </Modal>
  );
};

InfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  visibleMessage: PropTypes.bool.isRequired
};

export default InfoModal;
